export default "__VITE_ASSET__DF6C28Yk__"